<template>
    <common-modal v-if="isOpen" width="small" @close="emitEvent({ name: 'close' })">
        <common-content-wrapper width="small">
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.referrals.show.disclaimer_modal.heading')"
                    :isCenter="true"
                    size="medium"
                ></common-page-header>

                <p>{{ $t('pages.referrals.show.disclaimer_modal.content') }}</p>

                <common-buttons>
                    <common-button
                        :label="$t('pages.referrals.show.disclaimer_modal.buttons.cancel')"
                        :isSubmittable="false"
                        size="large"
                        type="secondary"
                        @click="emitEvent({ name: 'close' })"
                    ></common-button>
                    <common-button
                        :label="$t('pages.referrals.show.disclaimer_modal.buttons.continue')"
                        :isSubmittable="false"
                        size="large"
                        type="primary"
                        @click="emitEvent({ name: 'continue' })"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </common-content-wrapper>
    </common-modal>
</template>

<script>
    export default {
        props: {
            isOpen: { type: Boolean, required: true },
        },
    }
</script>
